import { Stack } from '@mui/material';
import { useState } from 'react';
import ListOfRouteDeviation from '../../../components/Escalations/ListOfRouteDeviation';
import VegaBreadCrumb from '../../../components/common/VegaBreadCrumb';
import VegaPageHeader from '../../../components/common/VegaPageHeader';
import { ROUTES } from '../../../router/routes';
import VegaButton from '../../../components/common/VegaButton';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { EscalationsServices } from '../../../Apis/EscalationsServices';
import { EscalationTriggerType } from '../../../types/request/escalationsRequest';
import { getErrorMessageFromErrorObj } from '../../../utils/api';

export enum RouteDeviationType {
  ROUTE_DEVIATION = 'Route Deviation',
  TRAIL = 'Trail',
}

const RouteDeviation = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { setSnackbar } = useSnackbar();

  const triggerEscalation = () => {
    EscalationsServices.triggerEscalation({
      triggerType: EscalationTriggerType.ROUTE_DEVIATION,
    })
      .then(res => {})
      .catch(error => {
        setSnackbar(getErrorMessageFromErrorObj(error), 'error');
      });
  };
  return (
    <>
      <VegaPageHeader
        sx={{
          pb: 0,
        }}
        renderLeftView={() => {
          return (
            <Stack gap={1} width={'100%'}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <VegaBreadCrumb
                  items={[
                    { label: 'Escalation', link: ROUTES.ESCALATIONS },
                    { label: `Route Deviation` },
                  ]}
                />
                <VegaButton
                  text="Trigger Escalation"
                  onClick={triggerEscalation}
                />
              </Stack>
            </Stack>
          );
        }}
      />
      <ListOfRouteDeviation selectedTab={selectedTab} />
    </>
  );
};

export default RouteDeviation;
